<template>
    <b-navbar toggleable="sm" type="dark" variant="dark" sticky>
        <b-navbar-toggle target="nav-collapse" />

        <b-button
            v-if="loggedIn"
            variant="primary"
            to="/dashboard"
            style="position: absolute; right: 24px; top: 9px;"
        >
            Dashboard
        </b-button>

        <b-button
            v-else
            variant="primary"
            to="/register"
            style="position: absolute; right: 24px; top: 9px;"
        >
            Get Started
        </b-button>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item to="/dashboard">Dashboard</b-nav-item>
                <b-nav-item to="/plans">Plans</b-nav-item>
                <b-nav-item to="/servers">Servers</b-nav-item>
                <b-nav-item to="/apps">Apps</b-nav-item>
                <b-nav-item to="/setup">Set up</b-nav-item>
                <b-nav-item to="/faq">FAQs</b-nav-item>
                <b-nav-item to="/referral">Affiliate</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    import Cookies from 'js-cookie'

    export default {
        computed: {
            loggedIn() {
                return !!Cookies.get('auth')
            }
        }
    }
</script>